<template lang="pug">
    div
      div
        lessonTitle
      stepTitle1 
      imageLoader
      div.initext
        initialText
      buttonNext
      lessonFooter
</template>

<script>

import lessonTitle from '@/components/lesson-title/lesson-title'
import stepTitle1 from '@/components/step-title1/step-title1'
import buttonNext from '@/components/button-next/button-next'
import salto from '@/components/button-next/salto'
import buttonReturn from '@/components/button-return/button-return'
import initialText from '@/components/initial-text/initial-text'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";

export default {
  name: 'Presentation2',
  components:{
    lessonTitle,
    stepTitle1,
    buttonNext,
    salto,
    buttonReturn,
    initialText,
    lessonFooter,
    imageLoader
  }
}
</script>

<style scoped>
@import 'presentation.scss';
</style>
